// Module
var code = "<section class=\"no-data\"> <h1>{{ 'dashboard.no_data_available.title' | translate }}</h1> <p> {{ 'dashboard.no_data_available.line1' | translate }} <br/> {{ 'dashboard.no_data_available.line2' | translate }} </p> </section> ";
// Exports
export default code;